import _asyncToGenerator from "/opt/render/project/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-af395c9e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "d-sm-flex flex-row align-items-center"
};
var _hoisted_2 = {
  class: "mt-1"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" uses ");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("Expired");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("Expire");

var _hoisted_6 = {
  class: "actions mt-2 mt-sm-0"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode("Copy");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("Delete");

import { computed } from "vue";
import { DateTime } from "luxon";
import { useDialog, useMessage } from "naive-ui";
import { UseTimeAgo } from "@vueuse/components";
import { handleError } from "@/utils/errors";
import http from "@/http";
export default /*#__PURE__*/_defineComponent({
  props: {
    link: null,
    withActions: {
      type: Boolean,
      default: false
    }
  },
  emits: ["removed"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var messageAPI = useMessage();
    var dialogAPI = useDialog();
    var expirationDate = computed(function () {
      if (!props.link.expirationDate) return;
      return DateTime.fromISO(props.link.expirationDate, {
        zone: "UTC"
      });
    });
    var expired = computed(function () {
      return !!expirationDate.value && expirationDate.value <= DateTime.now();
    });
    var full = computed(function () {
      return !!props.link.maxInvitations && props.link.usedInvitations >= props.link.maxInvitations;
    });
    var usable = computed(function () {
      return !full.value && !expired.value;
    });

    var remove = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(link) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return http.delete("/groups/removeinvitation/".concat(link.invitationId));

              case 3:
                emit("removed", link);
                messageAPI.success("The link has been removed");
                _context.next = 14;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                _context.t1 = messageAPI;
                _context.next = 12;
                return handleError(_context.t0, {
                  placeholder: "There was an error during the removing process"
                });

              case 12:
                _context.t2 = _context.sent;

                _context.t1.error.call(_context.t1, _context.t2);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function remove(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var copy = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(link) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return navigator.clipboard.writeText(link.link);

              case 3:
                messageAPI.success("The link has been copied");
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                messageAPI.error("The link could not be copied");

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }));

      return function copy(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    var onRemove = function onRemove(link) {
      var dialog = dialogAPI.warning({
        title: "Warning",
        content: "Are you sure you want to delete this link? It will no longer be usable and cannot be restored.",
        positiveText: "Delete",
        negativeText: "Cancel",
        onPositiveClick: function () {
          var _onPositiveClick = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    dialog.loading = true;
                    _context3.next = 3;
                    return remove(link);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function onPositiveClick() {
            return _onPositiveClick.apply(this, arguments);
          }

          return onPositiveClick;
        }()
      });
    };

    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      var _component_n_tag = _resolveComponent("n-tag");

      var _component_n_hr = _resolveComponent("n-hr");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_card = _resolveComponent("n-card");

      return _openBlock(), _createBlock(_component_n_card, {
        bordered: false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
            class: _normalizeClass(["details flex-fill", {
              'me-2': !!_ctx.$slots.actions
            }])
          }, [_createElementVNode("div", null, [_createVNode(_component_n_text, {
            strong: "",
            delete: !_unref(usable)
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(__props.link.link), 1)];
            }),
            _: 1
          }, 8, ["delete"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_n_tag, {
            size: "small",
            type: _unref(full) ? 'error' : 'default',
            class: "rounded-2"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(__props.link.usedInvitations) + " ", 1), __props.link.maxInvitations ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createTextVNode("/ " + _toDisplayString(__props.link.maxInvitations), 1)], 64)) : _createCommentVNode("", true), _hoisted_3];
            }),
            _: 1
          }, 8, ["type"]), _unref(expirationDate) ? (_openBlock(), _createBlock(_component_n_tag, {
            key: 0,
            size: "small",
            class: "rounded-2 ms-1",
            type: _unref(expired) ? 'error' : 'default'
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(UseTimeAgo), {
                time: _unref(expirationDate).toJSDate()
              }, {
                default: _withCtx(function (_ref4) {
                  var timeAgo = _ref4.timeAgo;
                  return [_renderSlot(_ctx.$slots, "time", {
                    time: timeAgo
                  }, function () {
                    return [_unref(expired) ? (_openBlock(), _createElementBlock(_Fragment, {
                      key: 0
                    }, [_hoisted_4], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                      key: 1
                    }, [_hoisted_5], 64)), _createTextVNode(" " + _toDisplayString(timeAgo), 1)];
                  })];
                }),
                _: 3
              }, 8, ["time"])];
            }),
            _: 3
          }, 8, ["type"])) : _createCommentVNode("", true)])], 2), __props.withActions ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_n_hr), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "actions", {
            usable: _unref(usable)
          }, function () {
            return [_unref(usable) ? (_openBlock(), _createBlock(_component_n_button, {
              key: 0,
              type: "info",
              size: "small",
              class: "me-2",
              secondary: "",
              onClick: _cache[0] || (_cache[0] = function ($event) {
                return copy(__props.link);
              })
            }, {
              default: _withCtx(function () {
                return [_hoisted_7];
              }),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_n_button, {
              type: "error",
              size: "small",
              secondary: "",
              onClick: _cache[1] || (_cache[1] = function ($event) {
                return onRemove(__props.link);
              })
            }, {
              default: _withCtx(function () {
                return [_hoisted_8];
              }),
              _: 1
            })];
          })])], 64)) : _createCommentVNode("", true)])];
        }),
        _: 3
      });
    };
  }
});